export const devOnly = (domain) => {
  const allowedDomains = ['dora.mapstack.io']
  const disallowedDomains = [
    'mapstack.io',
    'staging.mapstack.io',
    'chamnol.mapstack.io',
    'long.mapstack.io'
  ]
  return allowedDomains.includes(domain) && !disallowedDomains.includes(domain)
}
